import React, { useState } from "react";
import "./Banner.scss";
import BgRing from "../../assests/images/banner-bg-ring.svg";
import FiveStar from "../../assests/images/five-star.svg";
import TrustPilot from "../../assests/images/trustpilot.svg";
import BlackCheckMark from "../../assests/images/black-checkmark.svg";
import PadLock from "../../assests/images/padlock.svg";
import { useNavigate } from "react-router";
const Banner = () => {
  const navigate = useNavigate();
  const [activeButton, setActiveButton] = useState(null);

  const handleButtonClick = (text) => {
    setActiveButton(text);

    if (text.toUpperCase() === "PRIVATE") {
      navigate("/form/sorry");
    } else {
      localStorage.setItem("selectedButtonText", text);
      navigate("/form");
    }
  };
  return (
    <div className="b_body">
      <section className="banner container1286">
        <figure className="banner__ring">
          <img src={BgRing} alt="" srcSet="" />
        </figure>
        <div className="wrapper ">
          <div className="banner__details">
            <div className="banner__details-rating">
              <span>
                <strong>Excellent</strong>
              </span>
              <span>
                <img src={FiveStar} alt="" />
              </span>
              <span>
                <strong>1,135+</strong> Reviews On
              </span>
              <span>
                <img src={TrustPilot} alt="" />
              </span>
            </div>
            <div className="banner__details-header">
              <h1>
                <span className="banner-different">See If You Qualify</span> For
                <span className="break">Housing Disrepair</span>
                <span className="break">
                  {" "}
                  Compensation{" "}
                  <span className="n2 banner-different ">In 30 Seconds</span>
                </span>
              </h1>
            </div>
            <div className="banner__details-list">
              <li>
                <figure>
                  <img src={BlackCheckMark} alt="" />
                </figure>
                <div className="listPoints">
                  Any disrepair issues valued over £1,000 - may qualify.
                </div>
              </li>
              <li>
                <figure>
                  <img src={BlackCheckMark} alt="" />
                </figure>
                <div>
                  Complete confidentiality —{" "}
                  <strong>your tenancy is never at risk</strong>.
                </div>
              </li>
              <li>
                <figure>
                  <img src={BlackCheckMark} alt="" />
                </figure>
                <div>
                  <strong>Pay nothing&nbsp;</strong> for our service unless we
                  win your case.
                </div>
              </li>
            </div>
            <div className="banner__details-review desk-show">
             
              <div className="review-details">
                <p>
                Claim Solutions Scotland Ltd T/A Housing Disrepair Heroes is a Claims Management Company (CMC). You do not have to use a Claims Management Company or Solicitor to pursue a claim. You can claim for free, without using a claims management company, first to your landlord or to the Housing Ombudsman Service (England)/Public Services Ombudsman (Scotland & Wales).
                </p>
              
              </div>
            </div>
          </div>
          <div className="banner__card">
            <h2>Who do you rent from?</h2>
            <p>
              Living in Disrepair? Get the Life-Changing Compensation You
              Deserve!
            </p>
            <div className="banner__card-buttons">
              {["Council", "Housing Association", "Private"].map(
                (text, index) => (
                  <div className="button" key={index}>
                    <button
                      onClick={() => handleButtonClick(text)}
                      className={activeButton === text ? "active" : ""}
                    >
                      {text}
                    </button>
                  </div>
                )
              )}
            </div>
            <p>
              <span>
                <img
                  src={PadLock}
                  alt=""
                  width={12}
                  height={14}
                  className="pad-lock"
                />
              </span>
              <span className="safe_secure">
                Your Information is safe & secure
              </span>
            </p>
          </div>
          
        </div>
        <div className="banner__description desk-show">
          <h3>Disclaimer</h3>
          <p>
          Claim Solutions Scotland Ltd T/A Housing Disrepair Heroes is a Claims Management Company (CMC). You do not have to use a Claims Management Company or Solicitor to pursue a claim. You can claim for free, without using a claims management company, first to your landlord or to the Housing Ombudsman Service (England)/Public Services Ombudsman (Scotland & Wales).
          </p>
        </div>
      </section>
    </div>
  );
};
export default Banner;
